import {
  FETCH_IN_OUT_ORDER_TRANS,
  FETCH_IN_OUT_ORDER_TRANS_SUCCEED,
  FETCH_IN_OUT_ORDER_TRANS_FAILED,
  FETCH_IN_OUT_TRANS,
  FETCH_IN_OUT_TRANS_SUCCEED,
  FETCH_IN_OUT_TRANS_FAILED,
  FETCH_IN_OUT_TRANS_EXTERNAL,
  FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED,
  FETCH_IN_OUT_TRANS_EXTERNAL_FAILED,
  FETCH_WALLET_BALANCE,
  FETCH_WALLET_BALANCE_SUCCEED,
  FETCH_WALLET_BALANCE_FAILED,
  FETCH_TRANS,
  FETCH_TRANS_SUCCEED,
  FETCH_TRANS_FAILED,
  FETCH_EXT_TRANS,
  FETCH_EXT_TRANS_SUCCEED,
  FETCH_EXT_TRANS_FAILED,
  FETCH_ORDER_TRANS,
  FETCH_ORDER_TRANS_SUCCEED,
  FETCH_ORDER_TRANS_FAILED,
  FETCH_IN_OUT_ORDER_TRANS_CHART,
  FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED,
  FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED,
  FETCH_IN_OUT_TRANS_CHART,
  FETCH_IN_OUT_TRANS_CHART_SUCCEED,
  FETCH_IN_OUT_TRANS_CHART_FAILED,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED,
} from './action_types';

export default {
  // 1
  fetchInOutOrderTransAction: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS,
    params,
  }),

  fetchInOutOrderTransActionSucceed: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS_SUCCEED,
    params,
  }),

  fetchInOutOrderTransActionFailed: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS_FAILED,
    params,
  }),

  // 2
  fetchInOutTransAction: (params) => ({
    type: FETCH_IN_OUT_TRANS,
    params,
  }),

  fetchInOutTransActionSucceed: (params) => ({
    type: FETCH_IN_OUT_TRANS_SUCCEED,
    params,
  }),

  fetchInOutTransActionFailed: (params) => ({
    type: FETCH_IN_OUT_TRANS_FAILED,
    params,
  }),

  // 3
  fetchInOutTransExternalAction: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL,
    params,
  }),

  fetchInOutTransExternalActionSucceed: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED,
    params,
  }),

  fetchInOutTransExternalActionFailed: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL_FAILED,
    params,
  }),

  // 4
  fetchWalletBalanceAction: (params) => ({
    type: FETCH_WALLET_BALANCE,
    params,
  }),

  fetchWalletBalanceActionSucceed: (params) => ({
    type: FETCH_WALLET_BALANCE_SUCCEED,
    params,
  }),

  fetchWalletBalanceActionFailed: (params) => ({
    type: FETCH_WALLET_BALANCE_FAILED,
    params,
  }),

  // 5
  fetchTransAction: (params) => ({
    type: FETCH_TRANS,
    params,
  }),

  fetchTransActionSucceed: (params) => ({
    type: FETCH_TRANS_SUCCEED,
    params,
  }),

  fetchTransActionFailed: (params) => ({
    type: FETCH_TRANS_FAILED,
    params,
  }),

  // 6
  fetchExtTransAction: (params) => ({
    type: FETCH_EXT_TRANS,
    params,
  }),

  fetchExtTransActionSucceed: (params) => ({
    type: FETCH_EXT_TRANS_SUCCEED,
    params,
  }),

  fetchExtTransActionFailed: (params) => ({
    type: FETCH_EXT_TRANS_FAILED,
    params,
  }),

  // 7
  fetchOrderTransAction: (params) => ({
    type: FETCH_ORDER_TRANS,
    params,
  }),

  fetchOrderTransActionSucceed: (params) => ({
    type: FETCH_ORDER_TRANS_SUCCEED,
    params,
  }),

  fetchOrderTransActionFailed: (params) => ({
    type: FETCH_ORDER_TRANS_FAILED,
    params,
  }),
  // 8
  fetchInOutOrderTransChartAction: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS_CHART,
    params,
  }),

  fetchInOutOrderTransActionChartSucceed: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED,
    params,
  }),

  fetchInOutOrderTransActionChartFailed: (params) => ({
    type: FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED,
    params,
  }),

  // 9
  fetchInOutTransChartAction: (params) => ({
    type: FETCH_IN_OUT_TRANS_CHART,
    params,
  }),

  fetchInOutTransChartActionSucceed: (params) => ({
    type: FETCH_IN_OUT_TRANS_CHART_SUCCEED,
    params,
  }),

  fetchInOutTransChartActionFailed: (params) => ({
    type: FETCH_IN_OUT_TRANS_CHART_FAILED,
    params,
  }),

  // 10
  fetchInOutTransExternalChartAction: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL_CHART,
    params,
  }),

  fetchInOutTransExternalChartActionSucceed: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED,
    params,
  }),

  fetchInOutTransExternalChartActionFailed: (params) => ({
    type: FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED,
    params,
  }),

};
